<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Veteran'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteVeteran">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteVeteranDialog",
  emits: ["deleteVeteran"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      veteran: null,
      name: null,
    };
  },
  methods: {
    show(veteran) {
      (async () => {
        this.veteran = veteran;
        this.name = veteran.firstName + ' ' + veteran.lastName;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteVeteran() {
      this.$emit("deleteVeteran", this.veteran);
    },
  },
};
</script>
